"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModeBoundaryConditionSchema = void 0;
exports.isModeBoundaryCondition = isModeBoundaryCondition;
const zod_1 = require("zod");
const IBoundaryDefinition_1 = require("./IBoundaryDefinition");
exports.ModeBoundaryConditionSchema = zod_1.z.object({
    boundary: zod_1.z.lazy(() => IBoundaryDefinition_1.IBoundaryDefinitionSchema),
});
function isModeBoundaryCondition(condition) {
    return condition.boundary !== undefined;
}
//# sourceMappingURL=ModeBoundaryCondition.js.map